export default __webpack_public_path__ + "static/media/gigglyparkadventure.218a1251.png";